import { FC, SVGProps } from 'react';

interface IIconWalletProps extends SVGProps<SVGSVGElement> {
  color?: string;
  size?: number;
}

const IconWallet: FC<IIconWalletProps> = ({ color = 'var(--neutral_10)', size = 14, ...props }) => {
  const { style, ...rest } = props;
  const commonStyle = {
    flexShrink: 0,
    width: size,
    height: size,
    ...style,
  };

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      style={commonStyle}
      {...rest}
    >
      <path
        d="M11.5208 4.521H13.2708V12.6877H3.96654C3.48377 12.6877 3.09538 12.6879 2.78165 12.6623C2.46278 12.6363 2.18258 12.5813 1.92345 12.4493C1.5119 12.2395 1.17727 11.9049 0.96756 11.4934C0.835528 11.2342 0.780559 10.954 0.754507 10.6352C0.728874 10.3214 0.729157 9.93305 0.729157 9.45028V4.25838C0.729157 3.77561 0.728874 3.38722 0.754507 3.07349C0.780559 2.75461 0.835528 2.47442 0.96756 2.21529C1.17727 1.80374 1.5119 1.46911 1.92345 1.2594C2.18258 1.12737 2.46278 1.0724 2.78165 1.04635C3.09538 1.02071 3.48377 1.021 3.96654 1.021H11.5208V4.521ZM3.96654 1.896C3.46934 1.896 3.1227 1.89645 2.85285 1.9185C2.58814 1.94013 2.436 1.98028 2.32079 2.03898C2.07383 2.16481 1.87298 2.36567 1.74714 2.61263C1.68845 2.72784 1.64829 2.87998 1.62666 3.14469C1.60461 3.41454 1.60416 3.76118 1.60416 4.25838V9.45028C1.60416 9.94748 1.60461 10.2941 1.62666 10.564C1.64829 10.8287 1.68845 10.9808 1.74714 11.096C1.87298 11.343 2.07383 11.5438 2.32079 11.6697C2.436 11.7284 2.58814 11.7685 2.85285 11.7902C3.1227 11.8122 3.46934 11.8127 3.96654 11.8127H12.3958V5.396H2.62499V4.49906L9.34557 2.36112L9.92435 4.521H10.6458V1.896H3.96654ZM10.2083 7.5835C10.6916 7.5835 11.0833 7.97525 11.0833 8.4585C11.0833 8.94174 10.6916 9.3335 10.2083 9.3335C9.72507 9.3335 9.33332 8.94174 9.33332 8.4585C9.33332 7.97525 9.72507 7.5835 10.2083 7.5835ZM5.44339 4.521H9.01859L8.73746 3.47253L5.44339 4.521Z"
        fill={color}
      />
    </svg>
  );
};

export default IconWallet;
